import React from 'react';
import { useLang } from '../i18n/translations';
import { Landmark, Factory, Truck, Mountain, Store, Zap } from 'lucide-react';

export default function ONama() {
  const { t } = useLang();
  const areas = [
    { icon: Factory, title: 'Industrija i poduzetništvo', desc: 'Praćenje razvoja savremenih tehnika i tehnologija, poticaji razvoju privrede te priprema privrednih subjekata za IPA fondove EU.' },
    { icon: Mountain, title: 'Turizam i ugostiteljstvo', desc: 'Korištenje prirodnih bogatstava iz oblasti turizma i turističkih resursa Kantona, kao i ugostiteljstva i trgovine.' },
    { icon: Zap, title: 'Energija i rudarstvo', desc: 'Rudarstvo, geološka istraživanja, energetska efikasnost, obnovljivi izvori energije i energetski bilans.' },
    { icon: Truck, title: 'Cestovni saobraćaj', desc: 'Uređivanje uslova, načina i organizovanja prijevoza putnika i tereta na području Kantona, te taksi prijevoza.' },
    { icon: Store, title: 'Obrt i rad', desc: 'Obrt, poduzetništvo, rad i radni odnosi, zapošljavanje i zaštita na radu.' },
    { icon: Landmark, title: 'Kontrola cijena', desc: 'Praćenje i donošenje mjera radi neposredne kontrole cijena i zaštite potrošača.' }
  ];

  return (
    <div className="bg-[#f8f9fd] min-h-screen">
      <div className="bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold text-[#0b1a3d] mb-2" data-testid="onama-title">{t('about')}</h1>
          <p className="text-slate-500">Ministarstvo privrede Srednjobosanskog kantona / Ministarstvo gospodarstva Kantona Središnja Bosna</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-xl border border-slate-100 p-8 mb-10">
          <h2 className="text-2xl font-bold text-[#0b1a3d] mb-4">Nadležnosti Ministarstva</h2>
          <p className="text-slate-600 leading-relaxed">
            Ministarstvo privrede obavlja upravne, stručne i druge poslove utvrđene zakonom koji se odnose na ostvarivanje
            nadležnosti Kantona u oblasti privrede. Sjedište Ministarstva je u Travniku, ul. Prnjavor 16.
            Kroz informacijski sistem E-Turizam, Ministarstvo uspostavlja elektronski registar turističke ponude i
            smještajnih kapaciteta Srednjobosanskog kantona, čime se digitaliziraju administrativni procesi,
            povećava transparentnost i unapređuje turistička ponuda kantona.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((a, i) => (
            <div key={i} className="bg-white rounded-xl border border-slate-100 p-6 hover:shadow-lg hover:shadow-slate-200/60 transition-shadow duration-300">
              <div className="w-11 h-11 rounded-lg bg-[#e8ecf7] flex items-center justify-center mb-4">
                <a.icon className="h-5 w-5 text-[#001752]" />
              </div>
              <h3 className="font-semibold text-[#0b1a3d] mb-2">{a.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#001752] rounded-xl p-8 lg:p-10 mt-10 text-white">
          <h2 className="text-2xl font-bold mb-3">IS E-Turizam</h2>
          <p className="text-white/80 leading-relaxed max-w-3xl">
            Informacijski sistem E-Turizam obuhvata turistički vodič i registar turističke ponude Srednjobosanskog kantona.
            Sistem omogućava turistima jednostavan pristup informacijama o destinacijama, smještajnim kapacitetima i događajima,
            a nadležnim institucijama efikasno praćenje prijava i odjava turista te centralizovano upravljanje turističkim podacima.
          </p>
        </div>
      </div>
    </div>
  );
}
